import React from 'react';

import CasinoIcon from '@swf/core/assets/casino.svg';
import CreditCardIcon from '@swf/core/assets/icons/alternates/credit-card.svg';
import PhoneIcon from '@swf/core/assets/icons/alternates/phone.svg';
import PromotionsIcon from '@swf/core/assets/icons/alternates/promotions.svg';
import StarsRewardsIcon from '@swf/core/assets/icons/alternates/stars-rewards.svg';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import FacebookIcon from '@swf/core/assets/icons/facebook.svg';
import InstagramIcon from '@swf/core/assets/icons/instagram.svg';
import Language from '@swf/core/assets/icons/language.svg';
import StoreIcon from '@swf/core/assets/icons/store.svg';
import TwitchIcon from '@swf/core/assets/icons/twitch-social-icon.svg';
import TwitterIcon from '@swf/core/assets/icons/twitter.svg';
import YoutubeIcon from '@swf/core/assets/icons/youtube.svg';
import PokerIcon from '@swf/core/assets/poker.svg';
import SportsIcon from '@swf/core/assets/sports.svg';

interface Props {
  icon?: string;
  className?: string;
}

const Icon: React.FC<Props> = ({ icon, className }) => {
  switch (icon) {
    case 'creditcard':
      return <CreditCardIcon className={className} />;
    case 'phone':
      return <PhoneIcon className={className} />;
    case 'starsrewards':
    case 'rewards':
      return <StarsRewardsIcon className={className} />;
    case 'promotions':
      return <PromotionsIcon className={className} />;
    case 'poker':
      return <PokerIcon className={className} />;
    case 'casino':
      return <CasinoIcon className={className} />;
    case 'sports':
      return <SportsIcon className={className} />;
    case 'arrow':
      return <Arrow className={className} />;
    case 'language':
      return <Language className={className} />;
    case 'store':
      return <StoreIcon className={className} />;
    case 'facebook':
      return <FacebookIcon className={className} />;
    case 'twitter':
      return <TwitterIcon className={className} />;
    case 'youtube':
      return <YoutubeIcon className={className} />;
    case 'twitch':
      return <TwitchIcon className={className} />;
    case 'instagram':
      return <InstagramIcon className={className} />;
    default:
      return null;
  }
};

export default Icon;
